module.exports = __webpack_public_path__ + "static/media/HigherStudiesImg.43943710.png";